import operate from './operate'
export default function (IconFont) {
  return {
    leftColumns: [
      {
        title: '固定表头',
        width: 100,
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: '#CD170A',
                fontSize: '18px'
              },
              domProps: { // 添加标签,使用自己引入的iconfont图标
                innerHTML: "<i class='icon iconfont'>&#xe719;</i>"
              },
              on: {
                click: () => {
                  this.changeData('TableLeft', 'down', params.row)
                }
              }
            })
          ])
        }
      },
      {
        title: '启用',
        width: 80,
        [$field]: 'activeState',
        isEdit: true,
        render: (h, params) => {
          return h('Checkbox', {
            props: {
              value: params.row.activeState == 1
            },
            on: {
              'on-change': (e) => {
                if (e == true) {
                  params.row.activeState = 1
                } else {
                  params.row.activeState = 0
                }
              }
            }
          })
        }
      }, {
        title: '字段名称',
        [$field]: 'itemPropertie',
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row.itemPropertie
            },
            on: {
              input: (val) => {
                row.itemPropertie = val
              }
            }
          })
        }
      }, {
        title: '显示名称',
        [$field]: 'itemTitle',
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row.itemTitle
            },
            on: {
              input: (val) => {
                row.itemTitle = val
              }
            }
          })
        }
      }, {
        title: '显示宽度',
        [$field]: 'itemWidth',
        width: 100,
        render: (c, {row, index}) => {
          return c('InputNumber', {
            props: {
              min: 0,
              value: row.itemWidth || null,
              placeholder: '自动'
            },
            on: {
              'on-change': (e) => {
                row.itemWidth = e
              }
            }
          })
        }
      }, {
        title: '最小显示宽度',
        [$field]: 'itemMinWidth',
        width: 120,
        render: (c, {row, index}) => {
          return c('InputNumber', {
            props: {
              min: 0,
              value: row.itemMinWidth || null,
              placeholder: '自动'
            },
            on: {
              'on-change': (e) => {
                row.itemMinWidth = e
              }
            }
          })
        }
      }, {
        title: '操作',
        isEdit: true,
        width: 80,
        isOperate: true,
        slotComponent: operate
      }
    ],
    localColData: [
      {
        title: '固定表头',
        width: 100,
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: '#CD170A',
                fontSize: '18px',
                marginRight: '20px'
              },
              domProps: { // 添加标签,使用自己引入的iconfont图标
                innerHTML: "<i class='icon iconfont'>&#xe719;</i>"
              },
              on: {
                click: () => {
                  this.changeData('TableMiddle', 'down', params.row)
                }
              }
            }),
            h('span', {
              style: {
                color: '#CD170A',
                fontSize: '18px'
              },
              domProps: { // 添加标签,使用自己引入的iconfont图标
                innerHTML: "<i class='icon iconfont'>&#xe718;</i>"
              },
              on: {
                click: () => {
                  this.changeData('TableMiddle', 'up', params.row)
                }
              }
            })
          ])
        }
      },
      {
        title: '启用',
        width: 80,
        [$field]: 'activeState',
        isEdit: true,
        render: (h, params) => {
          return h('Checkbox', {
            props: {
              value: params.row.activeState == 1
            },
            on: {
              'on-change': (e) => {
                if (e == true) {
                  params.row.activeState = 1
                } else {
                  params.row.activeState = 0
                }
              }
            }
          })
        }
      }, {
        title: '字段名称',
        [$field]: 'itemPropertie',
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row.itemPropertie
            },
            on: {
              input: (val) => {
                row.itemPropertie = val
              }
            }
          })
        }
      }, {
        title: '显示名称',
        [$field]: 'itemTitle',
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row.itemTitle
            },
            on: {
              input: (val) => {
                row.itemTitle = val
              }
            }
          })
        }
      }, {
        title: '显示宽度',
        [$field]: 'itemWidth',
        width: 100,
        render: (c, {row, index}) => {
          return c('InputNumber', {
            props: {
              min: 0,
              value: row.itemWidth || null,
              placeholder: '自动'
            },
            on: {
              'on-change': (e) => {
                row.itemWidth = e
              }
            }
          })
        }
      }, {
        title: '最小显示宽度',
        [$field]: 'itemMinWidth',
        width: 120,
        render: (c, {row, index}) => {
          return c('InputNumber', {
            props: {
              min: 0,
              value: row.itemMinWidth || null,
              placeholder: '自动'
            },
            on: {
              'on-change': (e) => {
                row.itemMinWidth = e
              }
            }
          })
        }
      }, {
        title: '操作',
        isEdit: true,
        width: 80,
        isOperate: true,
        slotComponent: operate
      }
    ],
    rightColData: [
      {
        title: '固定表头',
        width: 100,
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: '#CD170A',
                fontSize: '18px'
              },
              domProps: { // 添加标签,使用自己引入的iconfont图标
                innerHTML: "<i class='icon iconfont'>&#xe718;</i>"
              },
              on: {
                click: () => {
                  this.changeData('TableRight', 'up', params.row)
                }
              }
            })
          ])
        }
      },
      {
        title: '启用',
        width: 80,
        [$field]: 'activeState',
        isEdit: true,
        render: (h, params) => {
          return h('Checkbox', {
            props: {
              value: params.row.activeState == 1
            },
            on: {
              'on-change': (e) => {
                if (e == true) {
                  params.row.activeState = 1
                } else {
                  params.row.activeState = 0
                }
              }
            }
          })
        }
      }, {
        title: '字段名称',
        [$field]: 'itemPropertie',
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row.itemPropertie
            },
            on: {
              input: (val) => {
                row.itemPropertie = val
              }
            }
          })
        }
      }, {
        title: '显示名称',
        [$field]: 'itemTitle',
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row.itemTitle
            },
            on: {
              input: (val) => {
                row.itemTitle = val
              }
            }
          })
        }
      }, {
        title: '显示宽度',
        [$field]: 'itemWidth',
        width: 100,
        render: (c, {row, index}) => {
          return c('InputNumber', {
            props: {
              min: 0,
              value: row.itemWidth || null,
              placeholder: '自动'
            },
            on: {
              'on-change': (e) => {
                row.itemWidth = e
              }
            }
          })
        }
      }, {
        title: '最小显示宽度',
        [$field]: 'itemMinWidth',
        width: 120,
        render: (c, {row, index}) => {
          return c('InputNumber', {
            props: {
              min: 0,
              value: row.itemMinWidth || null,
              placeholder: '自动'
            },
            on: {
              'on-change': (e) => {
                row.itemMinWidth = e
              }
            }
          })
        }
      }, {
        title: '操作',
        isEdit: true,
        width: 80,
        isOperate: true,
        slotComponent: operate
      }
    ]
  }
}
